import type { NonBillableReason } from "$global-providers/rxdb-provider/collections/epocus-exam";
import { styled, Typography } from "@material-ui/core";
import { EPOCUS_TEXT_SECONDARY, rem } from "../epocus-palette";
import {
  EnumChipSelect,
  WorksheetSection,
} from "../worksheets/worksheet-primitives";

const NON_BILLABLE_OPTIONS: { value: NonBillableReason; label: string }[] = [
  { value: "EDUCATIONAL", label: "Educational" },
  { value: "NOT_MEDICALLY_INDICATED", label: "Not medically indicated" },
];

const Hint = styled(Typography)({
  fontSize: rem(13),
  color: EPOCUS_TEXT_SECONDARY,
});

export const NonBillableControl: FC<{
  reason: NonBillableReason | null;
  onChange: (reason: NonBillableReason | null) => void;
  disabled: boolean;
  lockedMessage: string | null;
}> = ({ reason, onChange, disabled, lockedMessage }) => (
  <WorksheetSection label="Non-billable">
    <Hint>
      A non-billable study can still be signed and reviewed, but is never sent
      for billing.
    </Hint>
    <EnumChipSelect
      options={NON_BILLABLE_OPTIONS}
      selected={reason}
      onChange={(value) => onChange(value as NonBillableReason | null)}
      disabled={disabled}
    />
    {lockedMessage && <Hint>{lockedMessage}</Hint>}
  </WorksheetSection>
);
